/**
 * Reown AppKit 桌面布局 CSS（Pancake 式：只注入样式，不监听关窗、不 invalidate pairing）
 */

import { resetAppKitCssState } from './appkitCleanup.mjs'

export const DESKTOP_WC_BODY_CLASS = 'hieswap-wc-desktop-pairing'

const APPKIT_STYLE_ID = 'hieswap-appkit-ui'
/** 桌面 WC 分栏：AppKit 全屏遮罩压暗 + blur 叠在 Bridge 面板上会「啥也看不见」 */
const DESKTOP_WC_OVERLAY_BG = 'rgba(0, 0, 0, 0.1)'
const DESKTOP_WC_OVERLAY_BLUR = 'blur(1px)'

let desktopOverlayObserver = null

function patchAppKitModalOverlay(modal, active) {
  if (!modal) return
  if (active) {
    modal.style.setProperty('background-color', DESKTOP_WC_OVERLAY_BG, 'important')
    modal.style.setProperty('backdrop-filter', DESKTOP_WC_OVERLAY_BLUR, 'important')
  } else {
    modal.style.removeProperty('background-color')
    modal.style.removeProperty('backdrop-filter')
  }
}

/** 桌面 WC 配对中：压低 AppKit 遮罩，避免与 Bridge 面板叠成一片黑 */
export function applyAppKitDesktopOverlay(active) {
  if (typeof document === 'undefined') return
  document.querySelectorAll('w3m-modal, appkit-modal').forEach((el) => {
    patchAppKitModalOverlay(el, active)
  })
}

/** AppKit modal 晚于 pairing 挂载时补打一遍轻遮罩 */
export function ensureDesktopWcOverlayWatcher() {
  if (typeof document === 'undefined' || desktopOverlayObserver) return
  desktopOverlayObserver = new MutationObserver(() => {
    if (!document.body.classList.contains(DESKTOP_WC_BODY_CLASS)) return
    applyAppKitDesktopOverlay(true)
  })
  desktopOverlayObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  })
}

export function stopDesktopWcOverlayWatcher() {
  desktopOverlayObserver?.disconnect()
  desktopOverlayObserver = null
}

export function ensureAppKitLayoutStyles() {
  if (typeof document === 'undefined') return
  if (document.getElementById(APPKIT_STYLE_ID)) return
  const style = document.createElement('style')
  style.id = APPKIT_STYLE_ID
  style.textContent = `
    w3m-modal.open,
    appkit-modal.open {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    w3m-modal.open wui-flex,
    appkit-modal.open wui-flex {
      align-items: center !important;
      justify-content: center !important;
    }
    body.${DESKTOP_WC_BODY_CLASS} w3m-modal,
    body.${DESKTOP_WC_BODY_CLASS} appkit-modal {
      z-index: 2147483646 !important;
    }
    body.${DESKTOP_WC_BODY_CLASS} w3m-modal.open,
    body.${DESKTOP_WC_BODY_CLASS} appkit-modal.open {
      align-items: center !important;
      justify-content: center !important;
      padding: calc(58px + env(safe-area-inset-top, 0px)) 24px 24px !important;
      background-color: ${DESKTOP_WC_OVERLAY_BG} !important;
      backdrop-filter: ${DESKTOP_WC_OVERLAY_BLUR} !important;
    }
  `
  document.head.appendChild(style)
}

/** @deprecated 兼容 Tron WC；仅注入 CSS */
export function startAppKitUiEnhancements() {
  ensureAppKitLayoutStyles()
}

/** @deprecated AppKit 自管生命周期 */
export function stopAppKitUiEnhancements() {
  resetAppKitCssState()
}
